// Design Tokens - Transitions
// Use these tokens for all transition and animation values
// Based on FarLabs modern design system - Smooth, refined animations

export const transitions = {
  // Duration - Refined timing for modern UX
  duration: {
    instant: '100ms',
    fast: '150ms',
    normal: '200ms',
    medium: '300ms',
    slow: '400ms',
    slower: '500ms',
  },

  // Easing - Advanced curves for natural motion
  easing: {
    // Standard easings
    default: 'cubic-bezier(0.4, 0, 0.2, 1)',
    linear: 'linear',

    // Entrance animations
    in: 'cubic-bezier(0.4, 0, 1, 1)',
    inQuad: 'cubic-bezier(0.55, 0.085, 0.68, 0.53)',
    inCubic: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',

    // Exit animations
    out: 'cubic-bezier(0, 0, 0.2, 1)',
    outQuad: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    outCubic: 'cubic-bezier(0.215, 0.61, 0.355, 1)',

    // In-out animations
    inOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    inOutQuad: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
    inOutCubic: 'cubic-bezier(0.645, 0.045, 0.355, 1)',

    // Special easings for modern feel
    spring: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
    bounce: 'cubic-bezier(0.68, -0.6, 0.32, 1.6)',
    smooth: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
  },

  // Presets - Common transition combinations
  default: 'all 200ms cubic-bezier(0.4, 0, 0.2, 1)',
  fast: 'all 150ms cubic-bezier(0.4, 0, 0.2, 1)',
  slow: 'all 400ms cubic-bezier(0.4, 0, 0.2, 1)',
  smooth: 'all 300ms cubic-bezier(0.25, 0.1, 0.25, 1)',
  spring: 'all 400ms cubic-bezier(0.68, -0.55, 0.265, 1.55)',

  // Property-specific transitions
  color: 'color 200ms cubic-bezier(0.4, 0, 0.2, 1)',
  background: 'background-color 200ms cubic-bezier(0.4, 0, 0.2, 1)',
  border: 'border-color 200ms cubic-bezier(0.4, 0, 0.2, 1)',
  transform: 'transform 300ms cubic-bezier(0.25, 0.1, 0.25, 1)',
  opacity: 'opacity 200ms cubic-bezier(0.4, 0, 0.2, 1)',
  shadow: 'box-shadow 200ms cubic-bezier(0.4, 0, 0.2, 1)',
  filter: 'filter 200ms cubic-bezier(0.4, 0, 0.2, 1)',

  // Multiple properties
  colorAndBackground: 'color 200ms cubic-bezier(0.4, 0, 0.2, 1), background-color 200ms cubic-bezier(0.4, 0, 0.2, 1)',
  transformAndOpacity: 'transform 300ms cubic-bezier(0.25, 0.1, 0.25, 1), opacity 200ms cubic-bezier(0.4, 0, 0.2, 1)',

  // Interactive element transitions
  button: 'all 200ms cubic-bezier(0.4, 0, 0.2, 1)',
  buttonHover: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 200ms cubic-bezier(0.4, 0, 0.2, 1)',
  link: 'color 150ms cubic-bezier(0.4, 0, 0.2, 1)',
  modal: 'all 300ms cubic-bezier(0.25, 0.1, 0.25, 1)',
} as const;
